import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type EditType } from '../types';
import META from './useTrackAssetEditSaved.meta';

export type UseTrackAssetEditSavedParams = {
  edit_types: EditType[];
  size_width: number | null;
  size_height: number | null;
  crop_preset?: string;
  save_type: 'new_version' | 'new_asset';
};

export const useTrackAssetEditSaved = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetEditSaved = useCallback(
    (params: UseTrackAssetEditSavedParams) => {
      track(META.name, {
        ...params,
        category: 'asset_details',
      });
    },
    [track],
  );

  return { trackAssetEditSaved };
};
